<template>
  <v-container fluid>
    <v-row>
      <v-col md="4" cols="12" v-if="false">
        <v-row>
          <v-col cols="12">
            <h2>{{ $t("home.twitter") }}</h2>
          </v-col>
          <v-col>
            <v-card elevation="0" color="#26c6da" dark>
              <v-card-title>
                <v-icon large left> mdi-twitter </v-icon>
                <span class="text-h6 font-weight-light">Twitter</span>
              </v-card-title>
              <v-card-text>
                <Timeline
                  id="Previmeteo"
                  sourceType="profile"
                  :options="{ tweetLimit: '4' }"
                />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col md="12" cols="12">
        <v-row>
          <template v-if="user.favoris.length > 0 ">
            <v-col
              md="6"
              cols="12"
              v-for="(favoris, i) in user.favoris"
              :key="`fav${i}`"
            >
              <v-card
                elevation="0"
                color="grey lighten-5"
               
              >
                <v-card-title class="font-weight-bold">
                    <span style="cursor:pointer;" @click="$router.push(`/forecasts/${favoris.id_ville}/${favoris.libelle_lien}`)">{{ favoris.libelle_lien }} <template v-if="favoris.code_pays">- {{favoris.code_pays}}</template></span>
                    <v-spacer />
                    <v-tooltip top v-if="!isSubscribe(favoris.id_ville)">
                      <template v-slot:activator="{ on, attr }">
                        <v-btn
                          small
                          v-on="on"
                          v-bind="attr"
                          id="v-step-4"
                          elevation="0"
                          :loading="loading"
                          @click="subs()"
                          ><v-icon small>mdi-heart-outline</v-icon></v-btn
                        >
                      </template>
                      <span>{{ $t("add_to_favorites") }}</span>
                    </v-tooltip>
                    <v-tooltip top v-else>
                      <template v-slot:activator="{ on, attr }">
                        <v-btn
                          small
                          class="mr-1"
                          v-on="on"
                          v-bind="attr"
                          :loading="loading"
                          elevation="0"
                          right
                          color="primary"
                          @click="unsubs(favoris.id_favoris)"
                          ><v-icon small>mdi-heart</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("delete_from_favorites") }}</span>
                    </v-tooltip>
                </v-card-title>
                <v-card-text style="cursor:pointer;" @click="$router.push(`/forecasts/${favoris.id_ville}/${favoris.libelle_lien}/resum`)">
                  <v-row>
                    <v-col md="3"
                      ><v-img
                        contain
                        :src="`/pictos/0${favoris.forecast.ts}d.svg`"
                    /></v-col>
                    <v-col>
                      <span class="font-weight-bold text-h5"
                        ><v-icon>mdi-thermometer</v-icon>
                        {{ favoris.forecast.tmin }}</span
                      >
                      /
                      <span
                        class="
                          orange--text
                          text--lighten-2
                          font-weight-bold
                          text-h5
                        "
                        >{{ favoris.forecast.tmax }}</span
                      >°C<br />
                      <span class="font-weight-bold text-h5"
                        ><v-icon>mdi-weather-rainy</v-icon>
                        {{ favoris.forecast.apcpsfc.toFixed(2) }}</span
                      >mm<br />
                      <span class="font-weight-bold ml-1"
                        ><v-icon small>mdi-weather-windy</v-icon>
                        {{
                          Math.round(favoris.forecast.wind_speed)
                        }}</span
                      >
                      /
                      <span
                        class="orange--text text--lighten-2 font-weight-bold"
                        >{{ Math.round(favoris.forecast.gustsfc) }}</span
                      >km/h<br />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <router-link
                    :to="`/forecasts/${favoris.id_ville}/${favoris.libelle_lien}/resum`"
                    tag="a"
                    >{{ $t("home.card-more") }}</router-link
                  ></v-card-actions
                >
              </v-card>
            </v-col>
          </template>
          <template v-else>
            <v-col  v-if="$env.VUE_APP_WHITE_MARK_ID != 'monithermo'">
              <v-card elevation="0" color="grey lighten-3">
                <v-card-text>
                  <v-col class="text-center">
                    <h1>{{ $t("home.noFav") }}</h1>
                    <v-col class="py-12">
                      <v-autocomplete
                        v-model="model"
                        prepend-icon="mdi-magnify"
                        :items="items"
                        dense
                        rounded
                        :loading="isLoading"
                        filled
                        :search-input.sync="search"
                        hide-no-data
                        @change="goTo"
                        hide-selected
                        id="v-step-1"
                        item-text="search_nom"
                        :placeholder="$t('city_or_cp')"
                        return-object
                        no-filter
                      ></v-autocomplete>
                    </v-col>
                  </v-col>
                </v-card-text>
              </v-card>
            </v-col>
          </template>
          <v-col cols="12"
            ><h2>{{ $t("home.stations") }}</h2></v-col
          >
          <v-col
            md="3"
            cols="12"
            v-for="(station, i) in stationsFiltered"
            :key="i"
          >
            <v-card
              elevation="0"
              :disabled="!station.valide"
              :to="`/stations/${station.id_station}`"
              :color="station.last_data[0]?'info':'warning'"
              
              class="white--text"
            >
              <v-card-title>
                <h2>
                  {{ station.libelle_station }}
                </h2>
              </v-card-title>
              <v-card-text class="white--text">
                <v-row>
                  <v-col v-if="station.last_data[0]">
                      <b>Température :</b>
                    <span class="font-weight-bold "
                      >
                      {{ Math.round(station.last_data[0].temp) }}</span
                    >°C<br />
                      <b>Précipitation :</b>
                    <span class="font-weight-bold"
                      >
                      {{ station.last_data[0].rain }}</span
                    >mm<br />
                      <b>Vent</b>
                    <span class="font-weight-bold ml-1"
                      >
                      {{
                        Math.round(station.last_data[0].wind)
                      }}</span
                    >km/h<br />
                  </v-col>
                  <v-col v-else>
                    <h2>{{ $t("error.noDataAvailable") }}</h2>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <router-link
                  class="white--text"
                  :to="`/stations/${station.id_station}`"
                  tag="a"
                  >{{ $t("home.card-more") }}</router-link
                ></v-card-actions
              >
            </v-card>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12">
        <v-row>
          <v-col cols="12"
            ><h2>{{ $t("home.last_alerts") }}</h2>
            <router-link to="/alertes/v2/list">Voir plus...</router-link></v-col
          >

          <v-col>
            <v-simple-table height="50vh" fixed-header>
              <tbody>
                <tr v-for="(alert, i) in alertsList" :key="i">
                  <td>
                    <span>{{
                      moment(alert.date).format("dddd Do MMMM YYYY [à] H[h]mm")
                    }}</span
                    ><br />
                    <span v-html="alert.texte_complet"></span>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-snackbar top color="error" v-model="error">{{ errorMsg }}</v-snackbar>
  </v-container>
</template>

<script>
import Timeline from "vue-tweet-embed/dist/timeline";
import { mapState } from "vuex";
import api from "@/api";
import moment from "moment";
export default {
  components: {
    Timeline,
  },
  computed: {
    

    canSubscribe() {
      let limit = this.$checkLimit("bulletins_pdf");

      if (!limit) return true;

      if (this.user.bulletins_pdf.length >= limit) {
        return false;
      } else {
        return true;
      }
    },
    stationsFiltered() {
      if (!this.user.stations) return [];
      return this.user.stations.filter((map) => map.valide);
    },
    ...mapState(["user"]),
    fields() {
      if (!this.model) return [];

      return Object.keys(this.model).map((key) => {
        return {
          key,
          value: this.model[key] || "n/a",
        };
      });
    },
    items() {
      return this.entries.map((chunk) =>
        chunk.cp
          ? {
              ...chunk,
              search_nom: `${chunk.nom} (${chunk.cp.slice(0, 2)}) ${chunk.iso}`,
            }
          : { ...chunk, search_nom: `${chunk.nom} ${chunk.iso}` }
      );
    },
  },
  data: () => ({
    entries: [],
    model: null,
    search: null,
    isLoading: false,
    moment: moment,
    alertsList: [],
    error: false,
    loading:false,
    errorMsg: false,
  }),
  methods: {

    async unsubs(id_fav) {
      this.loading = true;
      console.log('unsub',id_fav);

      try {
        await api.users.unsubsfavorite(
          this.user.id_user,
          id_fav
        );

        let user = await api.users.get(this.user.id_user);

        this.$store.dispatch("setUser", user);
      } catch (err) {
        console.error(err.message);
      }
      this.loading = false;
    },
    isSubscribe(geoname) {
      let find = this.user.favoris.find(
        (map) => map.id_ville == geoname
      );

      return find ? true : false;
    },
    goTo() {
      this.$router.push(`/forecasts/${this.model.geoname}/${this.model.nom}/resum`);
    },
    async getAlerts() {
      let res = await api.alert.get(this.user.id_user);
      this.alertsList = res;
    },
  },
  mounted() {
    this.getAlerts();
    if (this.$route.query.error) {
      this.error = true;
      this.errorMsg = this.$route.query.error;
    }
  },
  name: "Home",
  watch: {
     search(val) {
      this.isLoading = true;

      // Lazily load input items
      api.cities
        .search(val)
        .then((res) => {
          this.entries = res;
          this.count = res.length;
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>
